export const bondVariableFloatRates = `
    CUSIP
    ISIN
    StartDate
    CouponFrequency
    CouponRate
    RateType
    PaymentDate
    EndDate
    ResetDays
    CouponResetDate
    CouponRateChangeDate
    `;

export const exchangeRate = `
    RateDate
    Rate
    QuoteCurrency
    BaseCurrency
`;

export const fxRates = `
    LocalCode
    Currency
    CurrencyFrom
    Type
    RateType
    Tenor
    Rate
    Bid
    Ask
    Date
`;
